// Birthday helpers shared by Add child and Edit child.
//
// Both screens offer the same month + year picker, and both must agree on how a
// birthday turns into an age — the backend derives `age` from `birthday` when
// it's set, so a mismatch here shows up as a kid whose age silently changes.

export const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MILLIS_IN_YEAR = 1000 * 60 * 60 * 24 * 365.25;

export function ageFromBirthday(birthday: Date): number {
  const diff = Date.now() - birthday.getTime();
  return Math.max(0, Math.floor(diff / MILLIS_IN_YEAR));
}

// Year options for the picker, covering ages 1..7 (the app's audience),
// most-recent first so a 1-year-old sits left-most.
//
// `extra` widens the list when an existing child's birth year falls outside it —
// otherwise opening Edit on an older kid would show a blank Year field and
// silently re-age them on save.
export function birthYearOptions(extra?: number | null): number[] {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 7 }, (_, i) => currentYear - 1 - i);
  if (extra != null && !years.includes(extra)) {
    years.push(extra);
    years.sort((a, b) => b - a);
  }
  return years;
}
